import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import withStyles from 'isomorphic-style-loader/withStyles';
// Components
import ToolTipSection from "../../Common/ToolTipSection/ToolTipSection";
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";
import ShowDescription from "../../Common/ShowDescription/ShowDescription";
import { PlanAvailableIcon } from "../../Common/Assets/SvgIconComponent/CommonSvgIcon";
import { getServicePlanValue } from "../../../helpers/GetDynamicItemName/dynamicHomeValue";
// Helpers & Config
import { photosShow } from "../../../helpers/photosShow";
import { servicePlansUploadDir } from "../../../config";
import messages from "../../../locale/jsonMessages";
import s from './ServicePlansInformation.css';


const ServicePlansInformation = ({ data, startDate, lateDate }) => {
    const { formatMessage, locale } = useIntl();
    const { planName, description } = getServicePlanValue(data, locale)
    const path = photosShow(servicePlansUploadDir);

    const benefitTool = data?.aiFeaturesStatus
        ? formatMessage(messages.benefitToolTip01)
        : formatMessage(messages.benefitToolTip02);

    return (
        <div className={s.servicePlansInfoContainer}>
            <div className={s.servicePlansInfoBox}>
                {/* Image + Basic Info */}
                <div className={s.servicePlansInfoTitleBox}>
                    <div className={s.servicePlansInfoImgBox}>
                        <div className={s.servicePlansInfoImgWrapper}>
                            <img src={path + data?.mediaImage} alt={data?.planName} className={s.servicePlansInfoImg} />
                        </div>
                        <div className={s.servicePlansInfoTitle}>{planName}</div>
                    </div>
                    <div className={s.servicePlansInfoBadge}>
                        {data?.userType === "renter"
                            ? formatMessage(messages.guest)
                            : formatMessage(messages.hostLabel)}
                    </div>
                </div>
                {/* Price & Date Info */}
                <div className={s.servicePlansPricingBox}>
                    <div>
                        <div className={s.servicePlansPricingTitleBox}>
                            <span className={s.servicePlansPricingTitleWrapper}>
                                <CurrencyConverter amount={data?.price} from={data?.currency} />&nbsp;
                                <span className={s.servicePlansPricingSecondaryTitle}>
                                    <span>/&nbsp;{data?.duration}</span>{" "}
                                    <span>
                                        {data?.duration == 1
                                            ? formatMessage(messages.month)
                                            : formatMessage(messages.monthsLabel)}
                                    </span>
                                </span>
                            </span>
                            <ToolTipSection label={formatMessage(messages.paymentPriceToolTip)} />
                        </div>
                        <ShowDescription description={description} count={70} />
                    </div>
                    <div className={s.servicePlansPricingInnerWrapper}>
                        {data?.duration && (
                            <div className={s.servicePlansPricingAmountBox}>
                                <span className={s.servicePlansPricingAmountTitle}>{formatMessage(messages.duration)}</span>
                                <span className={s.servicePlansPricingAmount}>
                                    {data?.duration}&nbsp;
                                    {data?.duration == 1
                                        ? formatMessage(messages.month)
                                        : formatMessage(messages.monthsLabel)}
                                </span>
                            </div>
                        )}
                        <div className={s.servicePlansPricingAmountBox}>
                            <span className={s.servicePlansPricingAmountTitle}>{formatMessage(messages.StartDate)}</span>
                            <span className={s.servicePlansPricingAmount}>{startDate}</span>
                        </div>
                        <div className={s.servicePlansPricingAmountBox}>
                            <span className={s.servicePlansPricingAmountTitle}>{formatMessage(messages.EndDate)}</span>
                            <span className={s.servicePlansPricingAmount}>{lateDate}</span>
                        </div>
                    </div>
                </div>
                {/* Benefits */}
                <div className={s.servicePlansBenefitsBox}>
                    <div className={s.servicePlansBenefitsTitle}>
                        <span className={s.servicePlansBenefitsTitleText}>{formatMessage(messages.benefitsLabel)}</span>
                        <ToolTipSection label={benefitTool} />
                    </div>
                    {data?.serviceFee >= 0 && (
                        <div className={s.servicePlansBenefitsFeature}>
                            <PlanAvailableIcon />
                            <span>
                                <span>{data?.serviceFee}%&nbsp;</span>
                                <span>{formatMessage(messages.serviceFee)}</span>
                            </span>
                        </div>
                    )}
                    {data?.aiFeaturesStatus && (
                        <div className={s.servicePlansBenefitsFeature}>
                            <PlanAvailableIcon />
                            <span>
                                <span><FormattedMessage {...messages.aiFeatureLabel} /></span>
                            </span>
                        </div>
                    )}
                </div>
            </div>
            {/* Tip Message */}
            <div className={s.servicePlansTipMessageBox}>
                {formatMessage(messages.theLabel)}&nbsp;
                <span className={s.servicePlansTipSpecialText}>{formatMessage(messages.planPaymentMessage01)}</span>&nbsp;
                {formatMessage(messages.planPaymentMessage)}
            </div>
        </div>
    );
};

export default withStyles(s)(ServicePlansInformation);
